import script from "./GalleryView.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryView.vue?vue&type=script&setup=true&lang=js"

import "./GalleryView.vue?vue&type=style&index=0&id=64950527&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64950527"]])

export default __exports__